import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Sidebar } from '@/components/layout/sidebar';
import { Topbar } from '@/components/layout/topbar';
import { requireAuth } from '@/lib/route-guards';

export const Route = createFileRoute('/_app')({
  beforeLoad: requireAuth,
  component: AppLayout,
});

function AppLayout() {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex flex-1 flex-col min-w-0">
        <Topbar />
        <main className="flex-1 overflow-auto">
          <div className="container max-w-7xl py-6 animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
